import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    direction: "ltr",
    marginTop: "-6px",
  },
  nameContainer: {
    display: "flex",
    justifyContent: "center",
    direction: "ltr",
    cursor: "pointer",
  },
  iconContainer: {
    marginRight: 7,
  },
  textContainer: {
    display: "flex",
    alignItems: "center",
  },
  item: {
    marginLeft: 20,
  },
  rtlItem: {
    marginRight: 20,
  },

  headerContainerEditMode: {
    marginTop: "20px",
  },
}));

export default useStyles;
